import { Box } from '@mui/material';
import React from 'react';
import PropTypes from 'prop-types';

const CustomInputLogisticSignature = (props) => {

  const formatSamples = () => {
    if (props.total === '' && props.collected === '') return '-';
    else if (props.total === '' && props.collected !== '')
      return `-/${props.collected}`;
    else if (props.total !== '' && props.collected === '')
      return `${props.total}/-`;
    else return `${props.total}/${props.collected}`;
  };

  return (
    <Box
      sx={{
        color: '#455066',
        fontFamily: 'Mulish',
        fontSize: '13px',
        lineHeight: '16px',
      }}
    >
      {formatSamples()}
    </Box>
  );
};
CustomInputLogisticSignature.propTypes = {
  collected: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    .isRequired,
  total: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};
export default CustomInputLogisticSignature;
